import React from 'react';
import PropTypes from 'prop-types';

const CustomFormSwitch = ({ register, dirtyFields, fieldName, errorMessage, readOnly }) => {

  // determine which css classes we'll apply to this field
  const inputClasses = []
   
  inputClasses.push('form-control')
  
  return (
    <>
     <div className="form-check form-switch ps-0">
          
          <input className={inputClasses.join(' ') + ' form-check-input ms-0 ps-0 fs-2'} data-testid={"fld" + fieldName}
              {...register(fieldName)}
            type="checkbox"  
            aria-invalid={errorMessage ? "true" : "false"}
          />

        </div>
      {errorMessage && <p role="alert">{errorMessage}</p>}
    </>
  );
};

CustomFormSwitch.propTypes = {
  fieldName: PropTypes.string.isRequired,  // name of the field
  dirtyFields: PropTypes.object,            // an array of which fields in the form are considered 'dirty'
  errorMessage: PropTypes.string,          // an error message if this field is failing validation
  register: PropTypes.func.isRequired      // used by react-hook-form 
};

export default CustomFormSwitch;